import React, { useRef, useState, useEffect } from "react";
import {
    PieChartLegendContainer, FormH1, LegendItem,
    ToolTipPointer,
    ToolTipContainer,
    ToolTipTopLine,
    ToolTipP,
    ToolTipFooter,
    ToolTipControl
} from "./PieChartElements";

import ReactDOM from 'react-dom';

const PieChartLegend = ({ id, outerData, innerData, setHoveredOuterIndex, setHoveredInnerIndex, onClickLeftWL, onClickLeft, onClickRight, demoState, demo, increaseDemoState }) => {

    const watchlistRef = useRef();
    const portfolioRef = useRef();
    const Tooltip = ({ targetRef, tipTitle = "", message, addTop = 0, addRight = 0 }) => {
        const [coords, setCoords] = useState({ top: 0, left: 0 });

        useEffect(() => {
            if (targetRef.current) {
                const rect = targetRef.current.getBoundingClientRect();
                setCoords({ top: rect.top + window.scrollY + addTop, right: window.innerWidth - rect.right + addRight });
            }
        }, [targetRef]);
        const top = `${coords.top}px`
        const right = `${coords.right}px`


        const triangleTop = coords.top + 20;
        const triangleRight = coords.right + 198;
        const topT = `${triangleTop}px`
        const rightT = `${triangleRight}px`

        return ReactDOM.createPortal(
            <><ToolTipContainer top={top} right={right}>
                <ToolTipTopLine>{tipTitle}</ToolTipTopLine>
                <ToolTipP>{message}</ToolTipP>
                <ToolTipFooter>
                    <ToolTipControl onClick={() => increaseDemoState()}>Next</ToolTipControl>
                    <>{`${demoState}/9`}</>
                </ToolTipFooter>
            </ToolTipContainer>

                <ToolTipPointer top={topT} right={rightT} />
            </>,
            document.body
        );
    };


    return (
        <PieChartLegendContainer>
            <FormH1 ref={watchlistRef}>Trade List</FormH1>
            {outerData.map((item, index) => (
                <LegendItem
                    key={item.label}
                    onMouseEnter={() => setHoveredOuterIndex(index)}
                    onMouseLeave={() => setHoveredOuterIndex(null)}
                    onClick={() => onClickLeftWL({ id: id, currentStock: item.label })}
                    onContextMenu={(e) => {
                        onClickRight(e, id, item.label);
                    }}
                    style={{ cursor: 'pointer', color: "fff" }}
                >
                    {item.label}
                </LegendItem>

            ))}
            {demo && demoState === 4 && <Tooltip targetRef={watchlistRef} addRight={-210} tipTitle={"Current Trade List"} message={"View stock details (left click) and remove stocks from trade consideration (right click)"} />}
            <FormH1>Portfolio</FormH1>
            {innerData.map((item, index) => (
                <LegendItem ref={portfolioRef}
                    key={item.label}
                    onMouseEnter={() => setHoveredInnerIndex(index)}
                    onMouseLeave={() => setHoveredInnerIndex(null)}
                    onClick={() => onClickLeft({ id: id, currentStock: item })}
                    style={{ cursor: 'pointer', color: "fff" }}
                >
                    {item.label}
                </LegendItem>
            ))}
            {demo && demoState === 5 && <Tooltip targetRef={portfolioRef} addRight={-210} addTop={-40} tipTitle={"Current Positions"} message={"Get more information on the stocks in your current portfolio"} />}
        </PieChartLegendContainer>
    );
};

export default PieChartLegend;